import React, { Component } from 'react';
import './index.scss';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import Api from '../../services/api';
import Slider from "react-slick";

// import de Componentes
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Product from '../../components/Product';
import SmallBanner from '../../components/SmallBanner';
// import BigBanner from '../../components/BigBanner';

// import de Imagens/SVG

import bgMobile from '../../assets/Images/bg-mobile.png'
import bgBig from '../../assets/Images/bg-big.png'
import Temperada from '../../assets/Images/temperada.png'
import Recheada from '../../assets/Images/recheada.png'
import Organica from '../../assets/Images/organica.png'
import Window from '../../assets/Images/window-cart.png'
import UberEats from '../../assets/Images/ubereats.png'
import iFood from '../../assets/Images/ifood.png'
import Acompanhamentos from '../../assets/Images/acompanhamentos.png'
import Bebidas from '../../assets/Images/bebidas.png'
import Molhos from '../../assets/Images/molhos.png'
import Sobremesas from '../../assets/Images/sobremesas.png'
import bannerLeft from '../../assets/Images/banner-left.png'
import bannerRight from '../../assets/Images/banner-right.png'

import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Carousel from 'react-bootstrap/Carousel'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons'

// class ProductsDisplay extends React.Component {
//   render () {
//     return (
//       <Row> 
//         <Col md={6} lg={3} className="d-flex justify-content-center">
//           <Product imageNormal={require("../../assets/Images/image-1.png")}
//           imageOver={require("../../assets/Images/image-1-hover.png")} />
//         </Col>
//         <Col md={6} lg={3} className="d-flex justify-content-center">
//           <Product imageNormal={require("../../assets/Images/image-2.png")}
//           imageOver={require("../../assets/Images/image-2-hover.png")} />
//         </Col>
//         <Col md={6} lg={3} className="d-flex justify-content-center">
//           <Product imageNormal={require("../../assets/Images/image-3.png")}
//           imageOver={require("../../assets/Images/image-3-hover.png")} />
//         </Col>
//         <Col md={6} lg={3} className="d-flex justify-content-center">
//           <Product imageNormal={require("../../assets/Images/image-4.png")}
//           imageOver={require("../../assets/Images/image-4-hover.png")} />
//         </Col>
//       </Row>
//     );
//   }
// }

interface StateProps { 
  user: User;
  param: Param;
}

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
}

interface OwnProps {}

class Home extends Component<StateProps & DispatchProps & OwnProps> {

  api: any = null;
  state: any = null;

  constructor (props) {
    super(props);
    this.api = new Api();
    this.state = {};
  }

  componentDidMount () {
  }

  render () {
    // if ( this.props.user.status === false ) {
    //   return <Redirect to='/login' />;
    // }

    const settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 3000,
      slidesToShow: 5,
      slidesToScroll: 2,
      swipeToSlide: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      responsive: [
        { breakpoint: 1480, settings: { slidesToShow: 4 } },
        { breakpoint: 1224, settings: { slidesToShow: 3 } },
        { breakpoint: 920, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } },
      ]
    }

    return (
      <>
        <Header/>
        <section className="carousel-container">
          <Carousel className="banner-carousel">
            <Carousel.Item>
              <picture>
                <source media="(max-width: 992px)" srcSet={bgMobile}/>
                <img
                  className="d-block w-100"
                  src={bgBig}
                  srcSet={`${bgMobile} 992w, ${bgBig} 993w`}
                  sizes="(max-width: 992px) 100%"
                  alt="Primeiro slide"/>
              </picture>
              <Carousel.Caption>
                <h2 className="carousel-title"> Confira nossa linha de carnes para espeto </h2>
                <p className="carousel-description">
                  Mais de 10 variedades de carnes separadas especialmente para
                  complementar o seu churrasco do fim de semana
                </p>
                <Button className="btn-primary-action carousel-cta">Eu quero ver!</Button>
              </Carousel.Caption>
            <div className="carousel-overlay"/>
            </Carousel.Item>
            <Carousel.Item>
              <picture>
                <source media="(max-width: 992px)" srcSet={bgMobile}/>
                <img
                  className="d-block w-100"
                  src={bgBig}
                  srcSet={`${bgMobile} 992w, ${bgBig} 993w`}
                  sizes="(max-width: 992px) 100%"
                  alt="Segundo slide"/>
              </picture>
              <Carousel.Caption>
                <h2 className="carousel-title"> Confira nossa linha de carnes para espeto </h2>
                <p className="carousel-description">
                  Mais de 10 variedades de carnes separadas especialmente para
                  complementar o seu churrasco do fim de semana
                </p>
                <Button className="btn-primary-action carousel-cta">Eu quero ver!</Button>
              </Carousel.Caption>
            <div className="carousel-overlay"/>
            </Carousel.Item>
            <Carousel.Item>
              <picture>
                <source media="(max-width: 992px)" srcSet={bgMobile}/>
                <img
                  className="d-block w-100"
                  src={bgBig}
                  srcSet={`${bgMobile} 992w, ${bgBig} 993w`}
                  sizes="(max-width: 992px) 100%"
                  alt="Terceiro slide"/>
              </picture>
              <Carousel.Caption>
                <h2 className="carousel-title"> Confira nossa linha de carnes para espeto </h2>
                <p className="carousel-description">
                  Mais de 10 variedades de carnes separadas especialmente para
                  complementar o seu churrasco do fim de semana
                </p>
                <Button className="btn-primary-action carousel-cta">Eu quero ver!</Button>
              </Carousel.Caption>
            <div className="carousel-overlay"/>
            </Carousel.Item>
          </Carousel>
        </section>

        <section className="selected-categories">
          <Row className="mx-0 d-flex justify-content-center categorie-container">
            <Col xs={12} lg={3} className="text-center categorie-col">
              <span className="w-100 categorie-title-container">
                <h3 className="text-center categorie-title"> Preparados/Recheados </h3>
                <span className="vertical-rule"/>
              </span>
              <span className="categories-img-container">
                <img src={Recheada} className="selected-categorie" alt="categoria"/>
              </span>
            </Col>
            <Col xs={12} lg={3} className="text-center categorie-col">
              <span className="w-100 categorie-title-container">
                <h3 className="text-center categorie-title"> Temperados </h3>
                <span className="vertical-rule"/>
              </span>
              <span className="categories-img-container">
                <img src={Temperada} className="selected-categorie" alt="categoria"/>
              </span>
            </Col>
            <Col xs={12} lg={3} className="text-center categorie-col">
              <span className="w-100 categorie-title-container">
                <h3 className="text-center categorie-title"> Cortes Orgânicos </h3>
                <span className="vertical-rule"/>
              </span>
              <span className="categories-img-container">
                <img src={Organica} className="selected-categorie" alt="categoria"/>
              </span>
            </Col>
          </Row>
        </section>

        <section className="vitrine produtos-em-destaque">
          
          <h2 className="mb-6 pt-5"> <span className="heading-border"> PRODUTOS </span> EM DESTAQUE </h2>
            {/* <Slider {...settings}> */}
            <Row>
              <Col xs={12}>
                <Slider {...settings}>
                  {/* <Product imageNormal={require("../../assets/Images/image-1.png")}
                  imageOver={require("../../assets/Images/image-1-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-2.png")}
                  imageOver={require("../../assets/Images/image-2-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-3.png")}
                  imageOver={require("../../assets/Images/image-3-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-4.png")}
                  imageOver={require("../../assets/Images/image-4-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-5.png")}
                  imageOver={require("../../assets/Images/image-5-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-6.png")}
                  imageOver={require("../../assets/Images/image-6-hover.jpg")} />
                  <Product imageNormal={require("../../assets/Images/image-4.png")}
                  imageOver={require("../../assets/Images/image-4-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-2.png")}
                  imageOver={require("../../assets/Images/image-2-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-3.png")}
                  imageOver={require("../../assets/Images/image-3-hover.png")} /> */}
                </Slider>
              </Col>
            </Row>
        </section>

        <section className="mini-banners">
          <div className="mini-banners-container">
            <SmallBanner bannerSrc={bannerLeft}/>
            <SmallBanner bannerSrc={bannerRight}/>
          </div>
          <div className="dark-bg-big">
            <Container className="delivery">
              <Row className="justify-content-center"> 
                <h2 className="heading-white"> Fique em casa, nós levamos nossos produtos até você! </h2>
              </Row>
              <Row className="subtitle-container">
                <h4> Faça seu pedido </h4>
                <hr/>
              </Row>
              <Row>
                <Col xs={12} lg={4} className="text-center delivery-type">
                  <p> Através do nosso site </p>
                  <img src={Window} alt=""/>
                </Col>
                <Col xs={12} lg={4} className="text-center delivery-type">
                  <p> Nas mais famosas plataformas de delivery </p>
                  <span className="delivery-types-container">
                    <img src={UberEats} alt="logo Uber Eats"/>
                    <img src={iFood} alt="logo iFood"/>
                  </span>
                </Col>
                <Col xs={12} lg={4} className="text-center delivery-type">
                  <p> Ou através de nossa central </p>
                  <span className="central-container">
                    <FontAwesomeIcon icon={faPhoneVolume}/>
                    <p> (41) 3335-7161 </p>
                  </span>
                </Col>
              </Row>
            </Container>
          </div>
        </section>

        <section className="mb-6 vitrine em-promocao">
          
          <h2 className="mb-6"> <span className="heading-border"> EM PROMOÇÃO </span> </h2>
          <Row>
              <Col xs={12}>
                <Slider
                // className="top-mini-header"
                dots={true}
                // arrows={true}
                autoplay={true}
                infinite={true}
                speed={500}
                autoplaySpeed={3000}
                cssEase={"linear"}
                slidesToShow={5}
                slidesToScroll={2}
                swipeToSlide={true}
                pauseOnHover={true}
                pauseOnFocus={true}
                responsive={[
                  { breakpoint: 1480, settings: { slidesToShow: 4 } },
                  { breakpoint: 1224, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                  { breakpoint: 920, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                  { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } }
                ]}
                >
                  {/* <Product imageNormal={require("../../assets/Images/image-1.png")}
                  imageOver={require("../../assets/Images/image-1-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-2.png")}
                  imageOver={require("../../assets/Images/image-2-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-3.png")}
                  imageOver={require("../../assets/Images/image-3-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-4.png")}
                  imageOver={require("../../assets/Images/image-4-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-5.png")}
                  imageOver={require("../../assets/Images/image-5-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-6.png")}
                  imageOver={require("../../assets/Images/image-6-hover.jpg")} />
                  <Product imageNormal={require("../../assets/Images/image-4.png")}
                  imageOver={require("../../assets/Images/image-4-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-2.png")}
                  imageOver={require("../../assets/Images/image-2-hover.png")} />
                  <Product imageNormal={require("../../assets/Images/image-3.png")}
                  imageOver={require("../../assets/Images/image-3-hover.png")} /> */}
                </Slider>
              </Col>
            </Row>
        </section>

        <section className="secondary-categories">
          <div className="cards-container">
            <Row className="mx-0 cards-row">
              <Col xs={12} sm={6} lg={3} className="card-wrapper">
                <div className="card-img-container">
                  <img src={Acompanhamentos} className="card-img" alt="categoria"/>
                  <div className="card-overlay">
                    <p className="card-title"> ACOMPANHAMENTOS </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} lg={3} className="card-wrapper">
              <div className="card-img-container">
                <img src={Molhos} className="card-img" alt="categoria"/>
                <div className="card-overlay">
                  <p className="card-title"> MOLHOS </p>
                </div>
              </div>
              </Col>
              <Col xs={12} sm={6} lg={3} className="card-wrapper">
              <div className="card-img-container">
                <img src={Bebidas} className="card-img" alt="categoria"/>
                <div className="card-overlay">
                  <p className="card-title"> BEBIDAS </p>
                </div>
              </div>
              </Col>
              <Col xs={12} sm={6} lg={3} className="card-wrapper">
              <div className="card-img-container">
                <img src={Sobremesas} className="card-img" alt="categoria"/>
                <div className="card-overlay">
                  <p className="card-title"> SOBREMESAS </p>
                </div>
              </div>
              </Col>
            </Row>
          </div>
          <div className="border-top-div">
            <hr className="horizontal-rule"/>
          </div>
        </section>

        <section className="contact-form">
          <Container className="contact-form-container">
            <h2 className="my-0 text-center heading-white"> Como podemos te ajudar? </h2>
            <p className="my-3 text-center"> Entre em contato com a gente! </p>
            <Form className="mt-5">
              <Form.Group controlId="user-name">
                <Form.Label> Seu Nome </Form.Label>
                <Form.Control size="lg" type="text" placeholder="Digite seu nome" />
              </Form.Group>
              <Form.Group controlId="user-email">
                <Form.Label> Seu Email </Form.Label>
                <Form.Control size="lg" type="email" placeholder="nome@exemplo.com" />
              </Form.Group>
              <Form.Group controlId="user-message">
                <Form.Label> Sua mensagem para nós </Form.Label>
                <Form.Control className="textarea-box" size="lg" as="textarea" rows={3} placeholder="Comece a escrever..."/>
              </Form.Group>
            </Form>
            <Button className="mb-6 btn-primary-action btn-contact-form"> Enviar </Button>
          </Container>
          <hr className="mt-6 horizontal-rule"/>
        </section>

        <Footer/>

      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
